import { getIconAssetPath } from "~/utils/assets";
export function getSpritePath() {
    return window.__spritePath__ || getIconAssetPath("sprite.svg");
}
export function getIconSprite(symbolId) {
    return `${getSpritePath()}#${symbolId}`;
}
